/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- EXPORT : FORM : FIELD : INFO : STYLES --------------- ++++++++++ */
export default {
	info: {
		display: 'block',
		color: theme.color.neutral.medium.swatch,
		fontSize: pxToEm(12),
		marginTop: pxToEm(5)
	}
};
